import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import UnitPlansEdit from "../../components/Units/UnitPlansEdit";


const EditUnitPlans = () => {
  return (
    <>
 

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Add Unit" /> */}

        {/* AddUserLayer */}
        <UnitPlansEdit />


    </>
  );
};

export default EditUnitPlans;